import { StepLayout } from 'components/StepLayout/StepLayout';
import React, { FC } from 'react';
import { useTranslation } from '@wix/wix-i18n-config';
import { SelectNameStepInput } from './components/SelectNameStepInput';
import { biEvents } from 'api/bi-events';
import { BI_ACTION_NAME, BI_STEP_NAME } from 'config/bi';
import { StepId } from 'config/steps';
import { useAppStore } from 'stores/appStore';
import { SelectNameStepSuggestions } from './components/SelectNameStepSuggestions';

export const SelectNameStep: FC = () => {
  const { t } = useTranslation();
  const storeName = useAppStore((state) => state.storeName);

  return (
    <StepLayout
      disclaimer={t('select-name-step.disclaimer')}
      description={t('select-name-step.description')}
      title={t('select-name-step.title')}
      nextButtonProps={{ label: t('select-name-step.primary-button'), disabled: !storeName }}
      onNext={() => {
        biEvents.actionClicked({
          screenName: BI_STEP_NAME[StepId.SelectName],
          action: BI_ACTION_NAME.CONTINUE,
        });
      }}
      onBack={() => {
        biEvents.actionClicked({
          screenName: BI_STEP_NAME[StepId.SelectName],
          action: BI_ACTION_NAME.BACK,
        });
      }}
    >
      <SelectNameStepInput />
      <SelectNameStepSuggestions />
    </StepLayout>
  );
};
